module.exports = {"PANEL_CODE_SUBMIT_SUCCESS_ALERT_TITLE":"Hecho!","PANEL_CODE_SUBMIT_SUCCESS_ALERT_DESCRIPTION":"Tu celular se ha verificado exitosamente 😄"}